import { EMAIL_REGEX } from '@Saral-Influencer-Marketing/saral-utils/src/constants';
import Joi from 'joi';

export const loginSchema = Joi.object({
  email: Joi.string().regex(EMAIL_REGEX).required().min(3).max(100).messages({
    'string.pattern.base': 'Please enter valid email address',
    'any.required': 'Please enter valid email address',
    'string.min': 'Please enter valid email address',
    'string.max': 'Please enter valid email address',
  }),
  password: Joi.string().required().messages({
    'any.required': 'Please enter a valid password',
  }),
});

export const validateLogin = async (body, setErrors, password) => {
  if (password.startsWith(' ')) {
    setErrors({ password: 'It seems you entered an extra space at the start' });
    return false;
  } else if (password.endsWith(' ')) {
    setErrors({ password: 'It seems you entered a trailing space' });
    return false;
  }
  const { error } = loginSchema.validate(body, { abortEarly: false });

  if (error) {
    const validationErrors = {};
    error.details.forEach((detail) => {
      validationErrors[detail.context.key] = detail.message;
    });

    setErrors(validationErrors);
    return false;
  }
  return true;
};
